import { render, staticRenderFns } from "./pendency-obligations.vue?vue&type=template&id=741d317f&scoped=true"
import script from "./pendency-obligations.vue?vue&type=script&lang=js"
export * from "./pendency-obligations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741d317f",
  null
  
)

export default component.exports